/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

const FullReviewDialog = ({ setShow, title, full_review }) => {
  const portalContainer = document.createElement('div');
  portalContainer.classList = 'c-dialog c-dialog--review';
  portalContainer.role = 'dialog';
  // portalContainer.ariaHidden = 'true';

  useEffect(() => {
    document.body.appendChild(portalContainer);

    return () => {
      document.body.removeChild(portalContainer);
    };
  }, [portalContainer]);

  return ReactDOM.createPortal(
    <>
      <div
        className="c-dialog__overlay"
        tabIndex="-1"
        data-a11y-dialog-hide
      ></div>

      <div
        className="c-dialog__container"
        role="dialog"
        aria-labelledby="dialog-title"
      >
        <button
          data-a11y-dialog-hide=""
          className="c-dialog__close"
          onClick={() => setShow(false)}
        >
          Close
        </button>

        <div className="c-dialog__content">
          <p className="o-text o-text--large o-text--heavy">'{title}'</p>

          <div
            className="o-text"
            dangerouslySetInnerHTML={{ __html: full_review }}
          ></div>
        </div>
      </div>
    </>,
    portalContainer
  );
};

export default FullReviewDialog;
